var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('m-pane',{ref:"tablePage",staticClass:"tablePage",attrs:{"config":_vm.config,"totalData":_vm.totalData,"pageTotal":_vm.pageTotal,"loading":_vm.loading,"pageID":"vehicleFreePlatform","currentPage":_vm.currentPage}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }